export const CHAT_WITH_MANAGER_LINK_ENV = process.env.REACT_APP_CHAT_WITH_MANAGER_LINK